/*
 * _customled-mega-menu-a11y.js  (Maranello M1.10.x)
 *
 * Accessibility patch for the PRODUCTS mega-menu toggle button per
 * pre-launch audit PL-I-02 (WCAG 4.1.2 Name/Role/Value).
 *
 * Vendor `assets/scripts.js` (class MegaMenuMain) toggles
 * `aria-expanded` on the `<mega-menu-main>` custom element parent.
 * The actual interactive button — `.button-mega-menu-toggle` — has
 * NO ARIA state, so screen readers don't announce:
 *   - that it controls a popup (no aria-haspopup)
 *   - whether the popup is open or closed (no aria-expanded on the
 *     button itself; only the parent has it, which most SR engines
 *     do not surface to the focused button)
 *
 * This file fixes that without touching the vendor scripts.js:
 *   1. On init, adds `aria-haspopup="menu"` + initial `aria-expanded`
 *      + `aria-controls` to each `.button-mega-menu-toggle` inside a
 *      `<mega-menu-main>`.
 *   2. Sets up a MutationObserver on each `<mega-menu-main>` that
 *      mirrors its `aria-expanded` attribute to the child toggle
 *      button. Vendor's show()/hide() methods continue to do their
 *      work unmodified; we just propagate the state to the right
 *      element for accessibility.
 *
 * M9.1 (2026-10-12): aria-haspopup="menu" REMOVED - the panel is a
 * disclosure of plain links (no role=menu/menuitem), so "menu" made
 * screen readers promise arrow-key navigation that never existed.
 * Disclosure pattern = aria-expanded + aria-controls only. Also mirrors
 * the left-rail category tab's .current class to aria-current="true"
 * so the active category is exposed, not just shown.
 *
 * REVERSAL: remove the script tag in _customled-stylesheets.liquid
 * (or delete this file). Mega menu functionality unchanged either way.
 */
(function () {
  "use strict";

  function ensureToggleAttrs(megaMenu) {
    var toggle = megaMenu.querySelector(".button-mega-menu-toggle");
    if (!toggle) return null;
    toggle.removeAttribute("aria-haspopup"); // M9.1: disclosure, not a menu
    // Initial state mirror.
    var expanded = megaMenu.getAttribute("aria-expanded") === "true" ? "true" : "false";
    toggle.setAttribute("aria-expanded", expanded);
    // aria-controls points to the wrapper that becomes the popup.
    var wrapper = megaMenu.querySelector(".mega-menu-main-wrapper");
    if (wrapper) {
      if (!wrapper.id) {
        wrapper.id = "mega-menu-main-wrapper-" + Math.random().toString(36).slice(2, 10);
      }
      toggle.setAttribute("aria-controls", wrapper.id);
    }
    return toggle;
  }

  function wire(megaMenu) {
    if (megaMenu.__customledA11yWired) return;
    megaMenu.__customledA11yWired = true;
    var toggle = ensureToggleAttrs(megaMenu);
    if (!toggle) return;

    // Mirror future aria-expanded changes (vendor show/hide flips the
    // attribute on the parent; we copy to the toggle).
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === "attributes" && m.attributeName === "aria-expanded") {
          var expanded = megaMenu.getAttribute("aria-expanded") === "true" ? "true" : "false";
          toggle.setAttribute("aria-expanded", expanded);
        }
      }
    });
    observer.observe(megaMenu, { attributes: true, attributeFilter: ["aria-expanded"] });

    // M9.1: left-rail category tabs - mirror .current to aria-current.
    var rail = megaMenu.querySelector(".mega-menu-main-nav");
    if (rail) {
      var syncRail = function () {
        var items = rail.querySelectorAll(".mega-menu-main-nav-item");
        for (var j = 0; j < items.length; j++) {
          if (items[j].classList.contains("current")) items[j].setAttribute("aria-current", "true");
          else items[j].removeAttribute("aria-current");
        }
      };
      syncRail();
      new MutationObserver(syncRail).observe(rail, { attributes: true, attributeFilter: ["class"], subtree: true });
    }
  }

  function init() {
    var menus = document.querySelectorAll("mega-menu-main");
    for (var i = 0; i < menus.length; i++) wire(menus[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
